@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
<div class="dialogContainer">
  <h2 mat-dialog-title class="header">
    Select Parent Entity
  </h2>
  @if (errorMessage()) {
    <div mat-dialog-content class="errorMessage">
      <pre>{{ errorMessage() }}</pre>
    </div>
  }
  @if (!isBusy() && results.data.length > 0) {
    <div mat-dialog-content>
      <mat-form-field>
        <input matInput placeholder="Entity ID" (keyup)="applyFilter($event.target)">
      </mat-form-field>
      <table mat-table [dataSource]="results" class="bordered-table">
        <ng-container matColumnDef="entity-id">
          <th mat-header-cell *matHeaderCellDef>Entity ID</th>
          <td mat-cell *matCellDef="let entity">{{ entity.id.entityId }};{{ entity.id.entityRevision }}</td>
        </ng-container>
        <ng-container matColumnDef="project-name">
          <th mat-header-cell *matHeaderCellDef>Project Name</th>
          <td mat-cell *matCellDef="let entity">{{ entity.projectName }}</td>
        </ng-container>
        <ng-container matColumnDef="unit-qty">
          <th mat-header-cell *matHeaderCellDef>Unit Quantity</th>
          <td mat-cell *matCellDef="let entity">{{ entity.totalUnitQty }}</td>
        </ng-container>
        <ng-container matColumnDef="total-cost">
          <th mat-header-cell *matHeaderCellDef>Total Cost</th>
          <td mat-cell *matCellDef="let entity">{{ entity.finalExtendedAmount | currency: 'USD' }}</td>
        </ng-container>
        <ng-container matColumnDef="updated-date">
          <th mat-header-cell *matHeaderCellDef>Updated Date</th>
          <td mat-cell *matCellDef="let entity">{{ entity.updateTimestamp | date: 'MM/dd/yyyy h:mm a':'UTC' }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let entityKey; let index; columns: displayedColumns" (click)="rowClicked(entityKey,index)"
        [class.background-grey]="index == cindex"></tr>
      </table>
    </div>
  }
  @if (!isBusy() && results.data.length > 0) {
    <div class="mat-dialog-actions">
      <button matButton="filled" class="send-button primary-button" (click)="saveAndClose()"> Submit</button>
      <button class="primary-button" matButton="filled" matDialogClose> Cancel</button>
    </div>
  }
</div>
